import { OktaAuthOptions } from '@okta/okta-auth-js';

import APP_ENV from './appEnv';

const BASENAME = window.location.origin;
const REDIRECT_URI = `${BASENAME}${APP_ENV.OKTA_REDIRECT_END_POINT}`;
const oktaConfig: OktaAuthOptions = {
  clientId: APP_ENV.OKTA_CLIENT_ID,
  issuer: APP_ENV.OKTA_ISSUER,
  redirectUri: REDIRECT_URI,
  scopes: ['openid', 'profile', 'email', 'offline_access'],
  pkce: APP_ENV.OKTA_ENABLE_PKCE,
};

export default oktaConfig;
